import instance from "../axios";

const getEvents = (offset: number) => {
  return instance.get(`/Admin/Events/GetEvents?Offset=${offset}`);
};

const createEvent = (event: any) => {
  return instance.post(`/Admin/Events/InsertEvent`, event);
};

const getEventById = (id: number) => {
  return instance.get(`/Admin/Events/GetEvent?IdEvent=${id}`);
};

const updateEvent = (event: any) => {
  return instance.put(`/Admin/Events/UpdateEvent`, event);
};

const getCurrencies = () => {
  return instance.get(`/Admin/Events/GetCurrencies`);
};

const EventService = {
  getEvents,
  createEvent,
  getEventById,
  updateEvent,
  getCurrencies,
};

export default EventService;
